import axios from "axios";
import Swal from 'sweetalert2';

const state = {
    opportunityList: [],
    opportunityArr: [],
    opportunityArray: [],
    opportunityID: "",
    selectedOpportunity: null,
    selectedLead: null,
    isEditing: "",

  };
  
  const mutations = {
    initializeStore(state){
      state.opportunityList = [];
      state.opportunityArr = [];
      state.opportunityArray = [];
      state.opportunityID = '';
      state.selectedOpportunity = null;
      state.selectedLead = null;
      state.isEditing = false;
    },
    SET_SELECTED_OPPORTUNITY(state, opportunity) {
      state.selectedOpportunity = opportunity;
      state.isEditing = true;
    },
    OPPORTUNITIES_ARRAY(state, opportunities){
      state.opportunityArray = opportunities;
    },
    LIST_OPPORTUNITIES(state, opportunities) {
      state.opportunityList = opportunities;
    },
    SET_SELECTED_LEAD(state, lead) {
      state.selectedLead = lead;
    },
    SET_STATE(state, payload) {
      for (const key in payload) {
          if (payload.hasOwnProperty(key) && key in state) {
              state[key] = payload[key];
          }
      }
    },
    SET_SEARCH_FILTERS(state, search_filter){
      for(const [key, value] of Object.entries(search_filter)){
         
      }
    },
    RESET_SEARCH_FILTERS(state){
     
    }

  };
  
  const actions = {
    updateState({ commit }, newState) {
      commit('SET_STATE', newState);
    },
    
    async createLeadOpportunity({ commit,state }, formData) {
      return axios.post('api/v1/create-lead-opportunity/', formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })
    },
  
    fetchLeadOpportunitys({ commit,state }, formData) {
      state.opportunityArr = [];
      axios.post(`api/v1/get-lead-opportunities/`,formData)
      .then((response)=>{
        for(let i=0; i< response.data.length; i++){
          state.opportunityArr.push((response.data[i].name + " - Value: " + response.data[i].value));
        }
        commit('LIST_OPPORTUNITIES', response.data);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    fetchLeadOpportunity({ commit,state }, formData) {
      axios.post(`api/v1/get-lead-opportunities/`,formData)
      .then((response)=>{
        state.selectedOpportunity = response.data;
        const selectedLead = response.data.lead.full_name + " - " + response.data.lead.email;
        
        commit('SET_SELECTED_OPPORTUNITY',response.data);
        commit('SET_SELECTED_LEAD',selectedLead);
      })
      .catch((error)=>{
        console.log(error.message);
      })
      
    },
    handleSelectedOpportunity({ commit, state }, option){
      state.opportunityArray = [];
      const selectedOpportunity = state.opportunityList.find(opportunity => (opportunity.name + " - Value: " + opportunity.value) === option);
      if (selectedOpportunity) {
          state.opportunityID = selectedOpportunity.opportunity_id;
          state.opportunityArray = [...state.opportunityArray, selectedOpportunity];
      }
      commit('OPPORTUNITIES_ARRAY', state.opportunityArray);
        
    },
  
    async updateLeadOpportunity({ commit,state }, formData) {
      return axios.put(`api/v1/update-lead-opportunity/`,formData)
      .then((response)=>{
        return response;
      })
      .catch((error)=>{
        console.log(error.message);
        throw error;
      })  
    },
  
    deleteLeadOpportunity({ commit,state }, formData) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you wish to delete Opportunity?`,
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes Delete Opportunity!',
        cancelButtonText: 'Cancel!',
        customClass: {
            confirmButton: 'swal2-confirm-custom',
            cancelButton: 'swal2-cancel-custom',
        },
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          axios.post(`api/v1/delete-lead-opportunity/`,formData)
          .then((response)=>{
            if(response.status == 200){
                Swal.fire("Poof! Opportunity removed succesfully!", {
                  icon: "success",
                }); 
            }else{
              Swal.fire({
                title: "Error Deleting Opportunity",
                icon: "warning",
              });
            }                   
          })
          .catch((error)=>{
            console.log(error.message);
            Swal.fire({
              title: error.message,
              icon: "warning",
            });
          })
        }else{
          Swal.fire(`Opportunity has not been deleted!`);
        }
      })
    },
  };
  
  const getters = {
    // users: (state) => state.users,
    // currentUser: (state) => state.currentUser,
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
  
  